module.exports = __webpack_public_path__ + "img/newicon8on.03b5472b.svg";